export function User({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 2.1748C10.4927 2.1748 11.7249 3.31336 11.873 4.76758L11.8877 5.0625C11.8803 6.6243 10.6647 7.88195 9.11523 7.94238H9.10645C9.0401 7.93645 8.97488 7.93763 8.91406 7.94141C7.31737 7.87687 6.1123 6.61529 6.1123 5.0625C6.1123 3.47029 7.40779 2.1748 9 2.1748Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.35"
        />
        <path
          d="M9.00903 10.2411C10.2843 10.2411 11.5233 10.5654 12.4358 11.1737C13.2404 11.7101 13.5994 12.3766 13.6047 13.0253C13.6028 13.6728 13.2414 14.3364 12.4338 14.8817C11.5177 15.4968 10.2761 15.825 9.00024 15.8251C7.72431 15.8251 6.48284 15.4968 5.56665 14.8817L5.5647 14.8807L5.41821 14.7782C4.71229 14.2586 4.39478 13.6363 4.39478 13.035C4.39478 12.3936 4.75577 11.7215 5.56958 11.1757C6.49052 10.5661 7.73406 10.2411 9.00903 10.2411Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.35"
        />
      </svg>
    </span>
  );
}
